import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M7.75 20V4.75L11.75 4.75M11.75 20V4.75M11.75 4.75H15.5M17.5 8.5L20.5 12L17.5 15.5" />
		<Path d="M2.75 9C2.75 11.3472 4.65279 13.25 7 13.25H7.75V4.75H7C4.65279 4.75 2.75 6.65279 2.75 9Z" fill="currentColor" />
	</SVG>
);
